import validate from "/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/src/middleware/auth.global.ts";
import manifest_45route_45rule from "/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  checkout: () => import("/src/middleware/checkout.ts"),
  "oci-punchout": () => import("/src/middleware/oci-punchout.ts")
}